/* global APP_ENV */

import 'whatwg-fetch'
import tippy from 'tippy.js'
import Honeybadger from 'honeybadger-js'
import $ from 'jquery'
import _ from 'underscore'

window.jQuery = window.$ = $
window._ = _

_.extend(tippy.Defaults, {
  animateFill: false,
  arrowSize: 'big',
  position: 'top-end',
  theme: 'nexia'
})

if (APP_ENV === 'production') {
  Honeybadger.configure({
    api_key: '03eef3bcd9e52f0b067110600e996842', // Public API key
    environment: APP_ENV
  })
}
